//import "@babel/polyfill";
import Vue from 'vue';
import { bugsnagClient } from './lib/bugsnag'
import bugsnagVue from '@bugsnag/plugin-vue'
import Form from './utilities/Form';
import VueFormWizard from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import VueMq from 'vue-mq'
import ToggleSwitch from 'vuejs-toggle-switch';
import VueScrollTo from 'vue-scrollto';
import Buefy from 'buefy';
import VTooltip from 'v-tooltip';
import VueNumeric from 'vue-numeric'
import SlitherSlider from 'slither-slider'

Vue.use(VueNumeric);
Vue.use(SlitherSlider);
Vue.use(VTooltip);

if (process.env.MIX_BUGSNAG_JS_ENABLE === 'true') {
    bugsnagClient.use(bugsnagVue, Vue)
}

// import Vuetify from 'vuetify/es5/components/Vuetify';

// Vue.use(Vuetify);
Vue.use(Buefy, {
    defaultIconPack: 'fas',
});
Vue.use(VueScrollTo);

Vue.use(ToggleSwitch);

require('./utilities/vue-toasted-registration').default;

Vue.use(VueMq, {
    breakpoints: {
        mobile: 414,
        tablet: 768,
        laptop: 1250,
        desktop: Infinity,
    }
})

Vue.use(VueFormWizard);

import lodash from 'lodash'
window._ = lodash;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.Vue = Vue;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios = require('axios').default;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.axios.interceptors.response.use(undefined, function (err) {
    if (err.response.status == 401 || err.response.status == 419) {
        let refresh = confirm("Your session has expired. Click 'OK' to redirect to the login page.");
        if (refresh) {
            location.reload();
        }
    }
    return Promise.reject(err);
})

window.Form = Form;
